import { AdjustedUnitPrice, Unit } from 'models/product';

// Function to get the primary unit
export function getPrimaryUnit(units: Unit[]): Unit | null {
  if (!units || units.length === 0) {
    return null;
  }

  const primaryGuestTypeKeys = getPrimaryGuestTypeKeys();

  for (const unit of units) {
    if (unit.method === 'PER_BOOKING') {
      return unit;
    } else if (unit.method === 'PER_PARTICIPANT') {
      if (primaryGuestTypeKeys.includes(unit.guest_type.key)) {
        return unit;
      }
    }
  }

  return units[0];
}

// Function to get the primary unit of adjusted unit prices
export function getAdjustedPrimaryUnit(units: AdjustedUnitPrice[]): AdjustedUnitPrice | null {
  if (!units || units.length === 0) {
    return null;
  }

  const primaryGuestTypeKeys = getPrimaryGuestTypeKeys();

  for (const unit of units) {
    if (unit.unit_price_method === 'PER_BOOKING') {
      return unit;
    } else if (unit.unit_price_method === 'PER_PARTICIPANT') {
      if (primaryGuestTypeKeys.includes(unit.guest_type_key)) {
        return unit;
      }
    }
  }

  return units[0];
}

// Function to get primary guest type keys
function getPrimaryGuestTypeKeys(): string[] {
  return [
    // Adult keys
    'Adult',
    '大人',
    '성인',
    '成人',
    '成人',

    // Adult/Child keys
    'Adult/Child',
    '大人子供共通',
    '성인/아동 공통',
    '成人儿童通用',
    '成人兒童通用',
  ];
}
